


























































































































































































































































































































































import { defineComponent } from '@nuxtjs/composition-api';
import {SfAccordion, SfLink, SfLoader, SfReview, SfTabs} from '~/components';
import HTMLContent from "../../../components/HTMLContent.vue";
import ProductAddReviewForm from "~/modules/catalog/product/components/ProductAddReviewForm.vue";
import { getMetaInfo } from '~/helpers/getMetaInfo';
import { useUiState } from "~/composables";

export default defineComponent ({
  name: "LegalInformation",
  components: {
    SfLink,
    ProductAddReviewForm, SfReview, SfLoader, HTMLContent,
    SfAccordion,
    SfTabs,
  },
  head() {
    return getMetaInfo({
      metaTitle: 'Вопросы и ответы Togas',
      metaDescription: 'Ответы на частые вопросы о доставке, оплате, возврате, бонусах и сервисе Togas.',
    });
  },
  setup() {
    const {
      toggleLoginModal,
    } = useUiState();

    const openPasswordResetForm = () => {
      console.log('openPasswordResetForm')
      toggleLoginModal();
    };

    return {
      openPasswordResetForm,
    }

  }
})
